import React from "react";
import db from "../../../services/query";
import { allReportPages } from "../../common/ParityReport";
import AriaReport, {
  buildPrintDocumentTitle,
  faDigits,
  usePrintData,
  usePrintDocumentTitle,
} from "./AriaReport";
import ariaLogo from "../../../svg/aria-university-logo.svg";

const photoUrl = (value) => {
  const raw = String(value || "").trim();
  if (!raw) return "";
  if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
  return `https://admission.saawis.com/img/${raw.replace(/^\//, "")}`;
};

export default function ExamCardsPrint({ location }) {
  const query = new URLSearchParams(location.search);
  const entryYearId = query.get("entryYearId") || "";
  const facultyId = query.get("facultyId") || "";
  const search = query.get("search") || "";
  const studentId = query.get("studentId") || "";
  const { loading, error, data } = usePrintData(
    async () => {
      if (studentId) {
        const { data: body } = await db.getAll(`students/applicants/${studentId}`);
        return { data: body?.data || [] };
      }
      const params = new URLSearchParams({ orderBy: "student_id", order: "desc" });
      if (entryYearId) params.set("entryYearId", entryYearId);
      if (facultyId) params.set("facultyId", facultyId);
      if (search) params.set("search", search);
      const rows = await allReportPages(`students/applicants?${params}`);
      return { data: rows };
    },
    [entryYearId, facultyId, search, studentId]
  );
  const rows = Array.isArray(data) ? data : [];
  const yearLabel = rows[0]?.entry_year || entryYearId || "";
  const pdfTitle = buildPrintDocumentTitle(["کارت امتحان کانکور", yearLabel]);
  usePrintDocumentTitle(pdfTitle);

  if (loading) return <p className="aria-report-status">در حال آماده‌سازی کارت‌ها…</p>;
  if (error) return <p className="aria-report-status" role="alert">{error}</p>;

  return (
    <main className="exam-cards-print print-volunteer-cards" dir="rtl">
      <style>{`@page{size:A4 portrait;margin:8mm}`}</style>
      <div className="aria-report-actions no-print">
        <button type="button" onClick={() => window.print()}>
          چاپ / Print
        </button>
      </div>
      <div className="print_body_main no_border">
        {rows.length === 0 ? (
          <p className="empty-note">هیچ کارت داوطلبی برای نمایش وجود ندارد.</p>
        ) : (
          rows.map((row, index) => (
            <div className="card_item" key={row.student_id || index}>
              <div className="exam_card">
                <div className="right_side">
                  <p>
                    کارت امتحان کانکور <span>{faDigits(row.entry_year || "")}</span>
                  </p>
                  <img src={ariaLogo} alt="" />
                </div>
                <div className="center_side">
                  <div className="profile">
                    <div className="img">
                      {photoUrl(row.student_photo) ? (
                        <img src={photoUrl(row.student_photo)} alt="" />
                      ) : (
                        <div className="exam-card-photo-fallback" />
                      )}
                      <hr />
                    </div>
                    <div className="title">
                      <p>
                        وزارت تحصیلات عالی
                        <br /> پوهنــــتون آریــــــا
                        <br /> معاونیت امور محصلان
                      </p>
                    </div>
                  </div>
                  <div className="information">
                    <ul>
                      <li>
                        <p>اسم</p>
                        <div className="print-student-name-block">
                          <span className="print-student-name">
                            {[row.student_name, row.student_lastname].filter(Boolean).join(" ")}
                          </span>
                          {row.aria_id ? (
                            <span className="print-student-code">{row.aria_id}</span>
                          ) : null}
                        </div>
                      </li>
                      <li>
                        <p>نام پدر</p>
                        <p>{row.student_father_name || "—"}</p>
                      </li>
                      <li>
                        <p>پوهنحی و رشته</p>
                        <p>{row.faculty || "—"}</p>
                      </li>
                      <li>
                        <p>شماره تماس</p>
                        <p dir="ltr">{row.student_phone || "—"}</p>
                      </li>
                      <li>
                        <p>ردیف/صنف</p>
                        <p />
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="left_side" />
              </div>
            </div>
          ))
        )}
      </div>
    </main>
  );
}
